/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Works_DescInputs */

const en_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected projects`)
};

const ar_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاريع مختارة`)
};

const bn_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাছাই করা প্রজেক্ট`)
};

const de_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ausgewählte Projekte`)
};

const es_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proyectos seleccionados`)
};

const fr_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projets sélectionnés`)
};

const pt_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projetos selecionados`)
};

const zh_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选定的项目`)
};

const tr_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seçilmiş projeler`)
};

const ru_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`избранных проектов`)
};

const pl_hero_works_desc = /** @type {(inputs: Hero_Works_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wybrane projekty`)
};

/**
* | output |
* | --- |
* | "selected projects" |
*
* @param {Hero_Works_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_works_desc = /** @type {((inputs?: Hero_Works_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Works_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_works_desc(inputs)
	if (locale === "bn") return bn_hero_works_desc(inputs)
	if (locale === "de") return de_hero_works_desc(inputs)
	if (locale === "es") return es_hero_works_desc(inputs)
	if (locale === "fr") return fr_hero_works_desc(inputs)
	if (locale === "pt") return pt_hero_works_desc(inputs)
	if (locale === "zh") return zh_hero_works_desc(inputs)
	if (locale === "tr") return tr_hero_works_desc(inputs)
	if (locale === "ru") return ru_hero_works_desc(inputs)
	if (locale === "pl") return pl_hero_works_desc(inputs)
	return en_hero_works_desc(inputs)
});